<template>
	<div>
		
		



		Hello
		{{serverStatus}}
		<el-button type="text" @click.prevent="$emit('view', 'sign-in')">Go Back</el-button>
		
	</div>
</template>

<script>

	import { mapGetters, mapActions } from "vuex";
	import { rest } from "@/utilities/rest.js";
	
	export default {
		name: "recover",
		props: ["data", "serverStatus"],

		data() {
			return {
				
				thinking: {
					save: false
				},

				serverError: null
			}
		}

		
	}
</script>